import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const NavigationTabsModuleAsyncComponent = AsyncComponent(async () => import('./navigation-tabs-module' /* webpackChunkName: "navigation-tabs-module" */ ));

export const NavigationTabsModuleAsync = (props) => {
  return <NavigationTabsModuleAsyncComponent {...props}/>
}
